import React, { Dispatch, PropsWithChildren, useState } from 'react';
import { IChatSession, IUserInfo, IChatbotSummaryResponse } from '../interfaces/app-interfaces';
import { IGCPChatApiResponse } from '../interfaces/gcp-api-response';
import { CHAT_BUTTON_TEXT, CHAT_HEADER_TEXT } from '../config/app-config';
import { IChatQueueType } from '../interfaces/case-details-api-interfaces';

interface ICAContextState {
  tenant?: string;
  locale: string;
  enableChatbot?: boolean;
  isProductAgentEnabled?: boolean;

  chatSession?: IChatSession;

  chatWindow: 'minimized' | 'maximized' | 'hidden';

  chatButtonText: string;
  chatHeaderText: string;
  isChatEventListenersAdded?: boolean;

  unreadMessages?: number;

  userInfo?: IUserInfo;
  gcpChatData?: IGCPChatApiResponse;
  availableSchedule?: {
    weekday: string;
    startTime: string;
    endTime: string;
  };

  isPrivacyPolicyAccepted?: boolean;
  endChatInfo?: {
    sessionType: 'chatbot' | 'miawChat';
    sessionId?: string;
  };
  scrollToBottom?: (elementId?: string) => void;
  playSoundMessageNotif?: () => void;

  chatWindowHandler: (action: 'show' | 'hide') => void;
  chatButtonHandler: (action: 'show' | 'hide') => void;
  chatbotSummaryResponse?: IChatbotSummaryResponse;
  customQueue?: IChatQueueType;
  enableBHCheckInEmode?: boolean;
  enableIsCustomerCheck?: boolean;
}

interface ICAContextProps {
  chatState: ICAContextState;
  setChatState: Dispatch<React.SetStateAction<ICAContextState>>;
}

export const CAContext = React.createContext<ICAContextProps>({
  chatState: {
    tenant: 'vistaprint',
    locale: 'en-us',
    chatWindow: 'minimized',
    chatButtonText: CHAT_BUTTON_TEXT.CHATBOT,
    chatHeaderText: CHAT_HEADER_TEXT.CHATBOT,
    chatWindowHandler: () => {},
    chatButtonHandler: () => {},
  },
  setChatState: () => {},
});

const CAProvider: React.FC<PropsWithChildren<ICAContextState>> = ({
  children,
  locale,
  // pageInfo,
  chatWindow,
  chatSession,
  enableChatbot,
  unreadMessages,
  scrollToBottom,
  isPrivacyPolicyAccepted,
  chatButtonText,
  chatHeaderText,
  tenant,
  enableBHCheckInEmode,
  enableIsCustomerCheck,
}) => {
  const [state, setState] = useState<ICAContextState>({
    tenant,
    locale,
    chatWindow,
    chatSession,
    enableChatbot,
    unreadMessages,
    scrollToBottom,
    isPrivacyPolicyAccepted,
    chatButtonText,
    chatHeaderText,
    enableBHCheckInEmode,
    enableIsCustomerCheck,
    chatButtonHandler: () => {},
    chatWindowHandler: () => {},
  });
  return (
    <CAContext.Provider
      value={{
        chatState: state,
        setChatState: setState,
      }}
    >
      {children}
    </CAContext.Provider>
  );
};

export { CAProvider };
